import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { FeldQueryFilterConfig, IFeldResponse } from 'fa-kt.types';
import { FeldService } from '../service';

@Component({
  selector: 'fa-kt-feld-filter',
  templateUrl: './feld-filter.component.html',
  styleUrls: ['./feld-filter.component.css'],
})
export class FeldFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public FeldFilterConfig: IFilterConfig<IFeldResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public feld: FeldService,
  ) {
    this.FeldFilterConfig = FeldQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.FeldFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.FeldFilterConfig[index].selections = shapes;
  }
}
